
<div
  :class="[content.theme, { 'h-100': !isHauteurPageAutomatique }]"
  class="d-flex flex-column main-compte"
>
  <vue-headful
    :title="titrePage"
    :description="content.description"
    :keywords="content.keywords"
    :image="metaOGImage"
    :url="metaUrl"
    :head="{
      'meta[name=robots]': { content: metaNoIndex },
      'link[hreflang=en-ca]': { href: pathAnglais },
      'link[hreflang=fr-ca]': { href: pathFrancais },
      'link[rel=apple-touch-icon]': { type: 'image/png' },
      'link[rel=icon]': { type: 'image/png' },
    }"
  />

  <!-- Ces 2 spans évitent erreur dans barreconnect-app.js -->
  <!-- TODO: À corriger dans lq-entete-connexion -->
  <!-- TODO: 2022-01-21 à détruire? ATTTENTION, utilisé dans 1c. Conserver cette ligne cause un doublon au niveau des id de la page. -->
  <!-- <span id="mel-topNotif"></span><span id="mel-notif"></span> -->

  <div class="w-100 h-100 d-flex align-items-center">
    <keep-alive>
      <main class="d-flex align-items-center h-100 px-0 col-md-12">
        <EditableArea v-if="content.main" class="w-100 h-100" :content="content.main" />
        <IframeHtmlSalesforce v-if="content.clavardage" :positionBulle="content.positionBulle" />
      </main>
    </keep-alive>
    <Aide :idRubriqueAide="content.idRubriqueAide"> </Aide>
  </div>

  <footer
    v-if="isPiedDePageVisible"
    id="footer"
    class="p-0"
    :class="$isMobile ? 'compteFonce' : content.themePiedDePage"
  >
    <Heritage class="piedDePage px-1" :content="contentHeritage" />
  </footer>
</div>
